import React from 'react';
import { Button } from 'ui';
import { StyledH1 } from 'pages/Race/Race/Race.styled';

export const StepTwo: React.FC = () => (
  <>
    <StyledH1>Application is sent</StyledH1>
    <Button.Link to="/race">Ok</Button.Link>
  </>
);
